import FooterSection from "../../commponents/layout/Footer";
import CoreValuesSection from "../../commponents/section/CoreValuesSection";
import HeroAboutUs from "../../commponents/section/HeroAboutUs";

import VisionMissionSection from "../../commponents/section/VisionMissionSection";
import { useHomePage } from "../../context/HomePageContext";

export default function AboutUs() {
  const { status } = useHomePage();

  // Kunjungan pertama: tunggu konten dari admin sebentar supaya teks bawaan
  // tidak sempat tampil lalu berganti.
  if (status === "loading") {
    return (
      <main
        aria-busy="true"
        className="flex min-h-screen w-full items-center justify-center">
        <div
          role="status"
          aria-label="Loading"
          className="h-12 w-12 animate-spin rounded-full border-4 border-[#324A5A]/30 border-t-[#324A5A]"
        />
      </main>
    );
  }

  return (
    <>
      <main className="relative z-0 min-h-screen w-full overflow-hidden">
        <HeroAboutUs />
        <VisionMissionSection />
        <CoreValuesSection />
        <FooterSection />
      </main>
    </>
  );
}
